import type {
  AuthByLoginOrEmailUserInput,
  AuthByOTPUserInput,
  AuthByPhoneAndPasswordInput,
  AuthByOneTimeAuthCodeInput,
  CreateUserByEmailInput,
  CreateUserByOTPInput,
  PhoneUserInput,
  CaptchaCheckSerializer,
} from "@litres-libs/types";

export type TLoginRequest =
  | AuthByOTPUserInput
  | AuthByLoginOrEmailUserInput
  | AuthByPhoneAndPasswordInput
  | AuthByOneTimeAuthCodeInput;

// TODO: remove _CreateUserByEmailInput since registration also requires otp_id and otp_code
export type TRegisterRequest = CreateUserByOTPInput | CreateUserByEmailInput;
export type PhoneUserInputCaptcha = PhoneUserInput & {
  jwtToken?: string;
};

export type RequestCaptchaCheck = CaptchaCheckSerializer;

export const providerNameMap = {
  sberid: "sb",
  yandex: "ya",
  mailru: "ma",
  facebook: "fb",
  google: "gp",
  vk: "vkid",
  vkid: "vkid",
  apple: "apple",
  x: "tw",
} as const;

export type ProviderKeys = keyof typeof providerNameMap;

// Note: добавил вручную, потому что после генерации типов происходит ковровый апдейт
export interface SocialProviders {
  provider: string;
  is_connection_bonus_received: boolean;
}
